import type { TeamSlug } from '@/app/(football)/[team]/_context/types';

import BenefitCard from './BenefitCard';

const TOTAL_CARDS = 5;
const LARGE_CARD_COUNT = 2;

// 하반기 전용 혜택 이미지가 있는 팀만 top-collector/second/ 하위 폴더에서 로드
// (하반기 이미지가 없으면 상반기 이미지를 그대로 재사용)
const getBenefitImageUrl = (teamSlug: string, index: number, useSecondSeasonImages: boolean) => {
  const seasonSegment = useSecondSeasonImages ? 'second/' : '';
  return `https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/top-collector/${seasonSegment}benefit_${index + 1}.webp`;
};

export interface BenefitCardGridProps {
  teamSlug: TeamSlug;
  /** 하반기 전용 이미지 노출 여부 (config 플래그 × 현재 시즌으로 상위에서 계산) */
  useSecondSeasonImages?: boolean;
}

export default function BenefitCardGrid({ teamSlug, useSecondSeasonImages = false }: BenefitCardGridProps) {
  return (
    <div className="flex w-full max-w-[320px] flex-col items-center gap-[10px]">
      {/* Row 1: Large Cards */}
      <div className="flex w-full items-center justify-center gap-[10px]">
        {Array.from({ length: LARGE_CARD_COUNT }, (_, index) => (
          <BenefitCard
            key={index}
            imageUrl={getBenefitImageUrl(teamSlug, index, useSecondSeasonImages)}
            size="large"
          />
        ))}
      </div>

      {/* Row 2: Small Cards */}
      <div className="flex w-full items-center justify-center gap-[10px]">
        {Array.from({ length: TOTAL_CARDS - LARGE_CARD_COUNT }, (_, index) => (
          <BenefitCard
            key={index + LARGE_CARD_COUNT}
            imageUrl={getBenefitImageUrl(teamSlug, index + LARGE_CARD_COUNT, useSecondSeasonImages)}
            size="small"
          />
        ))}
      </div>
    </div>
  );
}
